"use strict";

function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _react = _interopRequireWildcard(require("react"));
var _formWrapper = _interopRequireDefault(require("../../formWrapper.js"));
var _cccisdReduxFormHelpers = require("cccisd-redux-form-helpers");
var _cccisdToggle = _interopRequireDefault(require("cccisd-toggle"));
var _HelpText = _interopRequireDefault(require("./components/HelpText"));
var _Preview = _interopRequireDefault(require("../components/Preview"));
var _ComponentWrapper = _interopRequireDefault(require("./components/ComponentWrapper"));
var _Header = _interopRequireWildcard(require("./components/Header"));
var _AdvancedOptions = _interopRequireWildcard(require("./components/AdvancedOptions"));
var _ResourceDisplayOptions = _interopRequireWildcard(require("./components/ResourceDisplayOptions"));
var _Tags = _interopRequireWildcard(require("./components/Tags"));
var _Tabs = _interopRequireWildcard(require("./components/Tabs"));
var _style = _interopRequireDefault(require("./style.css"));
function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }
function _getRequireWildcardCache(e) { if ("function" != typeof WeakMap) return null; var r = new WeakMap(), t = new WeakMap(); return (_getRequireWildcardCache = function _getRequireWildcardCache(e) { return e ? t : r; })(e); }
function _interopRequireWildcard(e, r) { if (!r && e && e.__esModule) return e; if (null === e || "object" != _typeof(e) && "function" != typeof e) return { "default": e }; var t = _getRequireWildcardCache(r); if (t && t.has(e)) return t.get(e); var n = { __proto__: null }, a = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var u in e) if ("default" !== u && Object.prototype.hasOwnProperty.call(e, u)) { var i = a ? Object.getOwnPropertyDescriptor(e, u) : null; i && (i.get || i.set) ? Object.defineProperty(n, u, i) : n[u] = e[u]; } return n["default"] = e, t && t.set(e, n), n; }
function _slicedToArray(arr, i) { return _arrayWithHoles(arr) || _iterableToArrayLimit(arr, i) || _unsupportedIterableToArray(arr, i) || _nonIterableRest(); }
function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }
function _iterableToArrayLimit(r, l) { var t = null == r ? null : "undefined" != typeof Symbol && r[Symbol.iterator] || r["@@iterator"]; if (null != t) { var e, n, i, u, a = [], f = !0, o = !1; try { if (i = (t = t.call(r)).next, 0 === l) { if (Object(t) !== t) return; f = !1; } else for (; !(f = (e = i.call(t)).done) && (a.push(e.value), a.length !== l); f = !0); } catch (r) { o = !0, n = r; } finally { try { if (!f && null != t["return"] && (u = t["return"](), Object(u) !== u)) return; } finally { if (o) throw n; } } return a; } }
function _arrayWithHoles(arr) { if (Array.isArray(arr)) return arr; }
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
function _defineProperty(obj, key, value) { key = _toPropertyKey(key); if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == _typeof(i) ? i : String(i); }
function _toPrimitive(t, r) { if ("object" != _typeof(t) || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != _typeof(i)) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
function _toConsumableArray(arr) { return _arrayWithoutHoles(arr) || _iterableToArray(arr) || _unsupportedIterableToArray(arr) || _nonIterableSpread(); }
function _nonIterableSpread() { throw new TypeError("Invalid attempt to spread non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }
function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }
function _iterableToArray(iter) { if (typeof Symbol !== "undefined" && iter[Symbol.iterator] != null || iter["@@iterator"] != null) return Array.from(iter); }
function _arrayWithoutHoles(arr) { if (Array.isArray(arr)) return _arrayLikeToArray(arr); }
function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) arr2[i] = arr[i]; return arr2; }
var fields = ['title', 'description', 'pageTitle', 'showTitle', 'showTabs'].concat(_toConsumableArray(_Header.fields), _toConsumableArray(_AdvancedOptions.fields), _toConsumableArray(_ResourceDisplayOptions.fields), _toConsumableArray(_Tags.fields), _toConsumableArray(_Tabs.fields));
var validate = function validate(values, props) {
  var errors = _objectSpread(_objectSpread({}, (0, _Header.validate)(values, props)), (0, _Tabs.validate)(values, props));
  if (!values.title) {
    errors.title = 'Title is required.';
  }
  return errors;
};
var Form = function Form(props) {
  var _props$fields = props.fields,
    title = _props$fields.title,
    description = _props$fields.description,
    pageTitle = _props$fields.pageTitle,
    showTitle = _props$fields.showTitle,
    showTabs = _props$fields.showTabs;
  // prevents the addition of the showTabs key from being a breaking change
  if (!showTabs || ![true, false].includes(showTabs.value)) {
    showTabs.onChange(true);
    return null;
  }
  var _useState = (0, _react.useState)(['title', 'header', 'tags', 'tabs', 'resourceDisplayOptions', 'advancedOptions']),
    _useState2 = _slicedToArray(_useState, 2),
    collapsed = _useState2[0],
    setCollapsed = _useState2[1];
  var collapseAll = function collapseAll() {
    setCollapsed(['title', 'header', 'tags', 'tabs', 'resourceDisplayOptions', 'advancedOptions']);
  };
  var expandAll = function expandAll() {
    setCollapsed([]);
  };
  var handleCollapse = function handleCollapse(id) {
    if (collapsed.includes(id)) {
      return setCollapsed(collapsed.filter(function (tabId) {
        return tabId !== id;
      }));
    }
    return setCollapsed([].concat(_toConsumableArray(collapsed), [id]));
  };
  return /*#__PURE__*/_react["default"].createElement("div", null, /*#__PURE__*/_react["default"].createElement(_Preview["default"], {
    config: props.settings
  }), /*#__PURE__*/_react["default"].createElement("div", {
    style: {
      display: 'flex'
    }
  }, /*#__PURE__*/_react["default"].createElement("div", {
    className: _style["default"].pageTitle
  }, title.value), /*#__PURE__*/_react["default"].createElement("div", {
    className: _style["default"].pageMenu
  }, /*#__PURE__*/_react["default"].createElement("button", {
    type: "button",
    className: "btn btn-primary btn-xs",
    onClick: collapseAll,
    style: {
      marginRight: '1em'
    }
  }, "Collapse All"), /*#__PURE__*/_react["default"].createElement("button", {
    type: "button",
    className: "btn btn-primary btn-xs",
    onClick: expandAll
  }, "Expand All"))), /*#__PURE__*/_react["default"].createElement("div", {
    className: "panel-group",
    id: "accordion",
    role: "tablist",
    "aria-multiselectable": "true"
  }, /*#__PURE__*/_react["default"].createElement(_ComponentWrapper["default"], {
    title: "Resource Center Title",
    id: "title",
    handleCollapse: handleCollapse,
    collapsed: collapsed
  }, /*#__PURE__*/_react["default"].createElement(_HelpText["default"], {
    text: "Description and Page Title are not required. Label should be unique if possible. Label will show on page unless a Page Title is set."
  }), /*#__PURE__*/_react["default"].createElement(_cccisdReduxFormHelpers.TextBlock, {
    label: "Resource Center Label",
    field: title,
    required: true
  }), /*#__PURE__*/_react["default"].createElement(_cccisdReduxFormHelpers.FieldBlock, {
    field: pageTitle,
    label: "Page Title"
  }, /*#__PURE__*/_react["default"].createElement(_cccisdReduxFormHelpers.WysiwygEditor, {
    field: pageTitle,
    inputStyle: {
      minHeight: '100px'
    }
  })), /*#__PURE__*/_react["default"].createElement(_cccisdReduxFormHelpers.TextBlock, {
    label: "Description",
    field: description
  }), /*#__PURE__*/_react["default"].createElement(_cccisdToggle["default"], {
    value: showTitle.value,
    onChange: function onChange() {
      return showTitle.onChange(!showTitle.value);
    },
    label: "Show Page Title on page?"
  })), /*#__PURE__*/_react["default"].createElement(_ComponentWrapper["default"], {
    title: "Header",
    id: "header",
    handleCollapse: handleCollapse,
    collapsed: collapsed
  }, /*#__PURE__*/_react["default"].createElement(_HelpText["default"], {
    text: "The Header is optional. All Header fields are optional, except Name."
  }), /*#__PURE__*/_react["default"].createElement(_HelpText["default"], {
    text: "You can drag and drop Header Tabs to reorder them. Click and drag the handles to move them."
  }), /*#__PURE__*/_react["default"].createElement(_Header["default"], props)), /*#__PURE__*/_react["default"].createElement(_ComponentWrapper["default"], {
    title: "Tags",
    id: "tags",
    handleCollapse: handleCollapse,
    collapsed: collapsed
  }, /*#__PURE__*/_react["default"].createElement(_HelpText["default"], {
    text: "Tags are used for filtering resources. Internal Names should be unique. This Tag list is only used in this Resource Center."
  }), /*#__PURE__*/_react["default"].createElement(_Tags["default"], props)), /*#__PURE__*/_react["default"].createElement(_ComponentWrapper["default"], {
    title: "Tabs (Filter Groups)",
    id: "tabs",
    handleCollapse: handleCollapse,
    collapsed: collapsed
  }, /*#__PURE__*/_react["default"].createElement("div", {
    className: "form-group"
  }, /*#__PURE__*/_react["default"].createElement(_cccisdToggle["default"], {
    value: showTabs.value,
    onChange: function onChange() {
      return showTabs.onChange(!showTabs.value);
    },
    label: "Show Tabs on page?"
  }), !showTabs.value && props.fields.tabs.length > 1 && /*#__PURE__*/_react["default"].createElement("p", {
    className: "help-block"
  }, /*#__PURE__*/_react["default"].createElement("mark", null, "Warning: There are multiple tabs defined. Without showing tabs, there will be no way for the user to navigate between the tabs."))), /*#__PURE__*/_react["default"].createElement(_HelpText["default"], {
    text: "Tabs have different Filter Groups and Filter Tags associated with them. Tab Tag is required, and should have a unique name."
  }), /*#__PURE__*/_react["default"].createElement(_HelpText["default"], {
    text: "You can drag and drop Tabs, Filter Groups, and Tags to reorder them. Click and drag on the handles to move them."
  }), /*#__PURE__*/_react["default"].createElement(_Tabs["default"], props)), /*#__PURE__*/_react["default"].createElement(_ComponentWrapper["default"], {
    title: "Resource Display Options",
    id: "resourceDisplayOptions",
    handleCollapse: handleCollapse,
    collapsed: collapsed
  }, /*#__PURE__*/_react["default"].createElement(_HelpText["default"], {
    text: "These options affect how resources are displayed in this Resource Center."
  }), /*#__PURE__*/_react["default"].createElement(_ResourceDisplayOptions["default"], props)), /*#__PURE__*/_react["default"].createElement(_ComponentWrapper["default"], {
    title: "Advanced Options",
    id: "advancedOptions",
    handleCollapse: handleCollapse,
    collapsed: collapsed
  }, /*#__PURE__*/_react["default"].createElement(_AdvancedOptions["default"], props))));
};
var _default = exports["default"] = (0, _formWrapper["default"])({
  fields: fields,
  validate: validate
})(Form);